import { command } from "@lookiero/messaging";
const UPDATE_UI_SETTING = "update_ui_setting";
const updateUiSetting = ({ aggregateId, ...payload }) => ({
    ...command({
        aggregateId,
        name: UPDATE_UI_SETTING,
    }),
    ...payload,
});
export { UPDATE_UI_SETTING, updateUiSetting };
